import React from "react"
import { MainCP } from "../../../Components/confianza-empresa-cadem/confianza-empresa-cadem-v2/MainCP"

const ViewConfianzaCadem: React.FC = () => <MainCP/>

export default ViewConfianzaCadem